module.exports = __webpack_public_path__ + "img/fleet.0440499f.jpg";